module.exports = __webpack_public_path__ + "media/components/users/integrations/images/contact_integration-8c4c5dbdf4b0a49c23aefc2ea42776f8.svg";